import { teamMembers } from '../assets/siteData';
import { Section } from '../components/Section';

export function TeamPage() {
  return (
    <Section
      eyebrow="Team"
      title="A lean creative and technical team setup built for polished delivery"
      description="Each profile is presented like a premium talent card with clear role definition and visible skill stack."
    >
      <div className="team-grid">
        {teamMembers.map((member) => (
          <article className="team-card glass-panel" key={member.name}>
            {member.image ? (
              <img className="team-card__image" src={member.image} alt={member.imageAlt || member.name} />
            ) : (
              <div className="team-card__avatar">{member.initials}</div>
            )}
            <p className="eyebrow">{member.role}</p>
            <h3>{member.name}</h3>
            <div className="tag-row">
              {member.skills.map((item) => (
                <span className="tag" key={item}>
                  {item}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </Section>
  );
}
